export default __webpack_public_path__ + "static/figure-measure-reference-abe9162af7fb4772e6327690b11365af.jpg";